import { RecoActions } from "../reducerActions/RecoActions";

const initialState = {
    loadingDistricts:false,
    loadingSpeakers:false,
    loadingRecTypes:false,
    loadingRecMethods:false,
    districts:undefined,
    speakers:undefined,
    recTypes:undefined,
    recordingMethods:undefined
}

const RecoReducer = (state=initialState,action) => {

    const newState ={...state};

     if(action.type === RecoActions.SAVE_DISTRICTS){
        newState.districts = action.districts;
        newState.loadingDistricts = false;
    }
    else if(action.type === RecoActions.SAVE_SPEAKERS){
        newState.speakers = action.speakers;
        newState.loadingSpeakers = false;
    }
    else if(action.type === RecoActions.CLEAR_SPEAKERS){
        newState.loadingSpeakers=false;
        newState.speakers=undefined;
    }
    else if(action.type === RecoActions.SAVE_RECTYPES){
        newState.recTypes = action.recTypes;
        newState.loadingRecTypes = false;
    }
    else if(action.type === RecoActions.SAVE_RECMETHODS){
        newState.recMethods = action.recMethods;
        newState.loadingRecMethods = false;
    }
    else if(action.type === RecoActions.RESET){
        newState.loadingDistricts = false;
        newState.loadingSpeakers = false;
        newState.loadingAllSpeakers = false;
        newState.loadingRecTypes = false;
        newState.loadingRecMethods = false;
        newState.districts = undefined;
        newState.speakers = undefined;
        newState.recTypes = undefined;
        newState.recordingMethods = undefined;
    }
    return newState;
}

export default RecoReducer;